import htmlTemplateIndex from './index.html'
import './index.css'

export function showPageDemoFullHeight () {
  console.log('demo/layout-full-height')
  document.body.innerHTML = htmlTemplateIndex

  // Changing the colors by changing css variables in JS?
  setTimeout(changeStyle, 3000)
}

function changeStyle () {
  const currentColor = document.querySelector('.full-height').style.getPropertyValue('--color')
  console.log('currentColor', currentColor)
  document.querySelector('.full-height').style.setProperty('--color', 'red')
}
